import * as React from 'react';

import { cn } from '@/lib/utils';

interface InputFormProps extends React.ComponentProps<'input'> {
  error?: boolean;
}

const InputForm = React.forwardRef<HTMLInputElement, InputFormProps>(
  ({ className, type, error = false, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          `tw-flex tw-h-10 tw-w-full tw-rounded-md tw-border tw-border-input tw-bg-transparent tw-px-3 tw-py-2 tw-text-sm tw-transition-colors file:tw-border-0 file:tw-bg-transparent file:tw-text-sm file:tw-font-medium file:tw-text-foreground placeholder:tw-text-muted-foreground focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-ring disabled:tw-cursor-not-allowed disabled:tw-opacity-50 md:tw-text-sm ${
            error ? 'tw-border-red-600' : 'tw-border-zinc-200'
          }`,
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
InputForm.displayName = 'Input';

export { InputForm };
